import React from "react";
import { useSnackbar } from "notistack";
import { Button, Dialog, DialogActions, DialogContent, DialogTitle, Typography } from "@material-ui/core";
import { IconButton } from "@material-ui/core";
import { Close } from "@material-ui/icons";
import Moment from "moment";
import { EliminarTemaInteres } from "./requestTemasInteres";

function DialogEliminarTemaInteres(props) {
  const {
    noticia,
    dialog_close,
  } = props;

  const notistack = useSnackbar();

  /**
   * Handler para cancelar eliminación.
   */
  const handleCancelar = () => {
    dialog_close();
  }

  /**
   * Handler para aceptar eliminación.
   */
  const handleAceptar = () => {
    EliminarTemaInteres(noticia)
      .then(response => {
        notistack.enqueueSnackbar("Registro de Tema de Interés eliminado exitosamente.", {
          variant: "success",
          anchorOrigin: {
            horizontal: "center",
            vertical: "bottom"
          },
          action: <IconButton onClick={() => notistack.closeSnackbar()}><Close /></IconButton>
        });
      })
      .catch(error => {
        console.error(error);
        notistack.enqueueSnackbar("Error al intentar eliminar el Tema de Interés.", {
          variant: "error",
          anchorOrigin: {
            horizontal: "center",
            vertical: "bottom"
          },
          action: <IconButton onClick={() => notistack.closeSnackbar()}><Close /></IconButton>
        });
      })
      .finally(() => dialog_close());
  }

  return (
    <Dialog
      disableBackdropClick
      disableEscapeKeyDown
      maxWidth="xs"
      open={Boolean(noticia)}
    >
      <DialogTitle>{"Eliminar Registro Contrato Adjudicado"}</DialogTitle>
      <DialogContent dividers>
        <Typography variant="h6">{"Se debe confirmar la eliminación del Tema de Interés."}</Typography>
        <Typography>{`Título: ${noticia ? noticia.titulo : ""}`}</Typography>
        <Typography>{`Fecha de adjudicación: ${noticia ? Moment(noticia.fecha).format("DD/MM/YYYY HH:mm") : ""}`}</Typography>
        <Typography variant="overline">{"No podrá ser recuperado posteriormente."}</Typography>
      </DialogContent>
      <DialogActions>
        <Button onClick={handleCancelar} autoFocus variant="outlined" color="primary">
          {"Cancelar"}
        </Button>
        <Button onClick={handleAceptar} variant="contained" color="primary">
          {"Aceptar"}
        </Button>
      </DialogActions>
    </Dialog>
  );
}

export default DialogEliminarTemaInteres;